import { VStack, Heading, Button, Text, HStack, Checkbox, chakra, useDisclosure, Drawer, DrawerContent, DrawerCloseButton } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import React, { useState, useContext, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TextField from '../TextField';
import ChangeTitle from '../ChangeTitle';
import { AccountContext } from '../AccountContext';
import Contrato from '../../termos/deovita202606.pdf';
import NoUserHeader from '../AreaLivre/NoUserHeader';
import requestTimeout from '../Utils/Functions/requestTimeout';
import Pdf from '../PdfViewer';
import TermosGerais from '../../termos/Termos Gerais.pdf';
import { api } from 'api/api';
import useModelPagamentoTelemed from 'components/Dashboard/Telemedicina/useModelPagamentoTelemed';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const Conferencia = () => {
  ChangeTitle('Cadastro');
  const navigate = useNavigate();
  const { setUser, setPage, user } = useContext(AccountContext);
  const [termos, setTermos] = useState(false);
  const [termosGerais, setTermosGerais] = useState(false);
  const { state } = useLocation();
  const [error, setError] = useState(null);
  const hash = state?.hash || null;

  const timeOutInSeconds = process.env.REACT_APP_REQUEST_TIMEOUT_IN_SECONDS;
  setPage('Cadastro');
  const sexo_nome = () => {
    if (state.sexo === 'F') {
      return 'feminino';
    } else {
      return 'masculino';
    }
  };
  const { isOpen, onOpen, onClose } = useDisclosure();
  const finalRef = React.useRef(null);

  const disclousureTermosGerais = useDisclosure();
  const termosGeraisApp = useDisclosure();

  const { fetchVincularVoucher } = useModelPagamentoTelemed();

  function renderPage() {
    if (error === 'Seu cadastro já foi finalizado, faça login para continuar') {
      return (
        <>
          <Button colorScheme="teal" w="100%" onClick={() => navigate('/login')}>
            Ir para login
          </Button>
        </>
      );
    } else {
      return (
        <>
          <TextField name="nome" label="Nome Completo" isDisabled={true} />
          <HStack>
            <TextField name="cpf" label="CPF" isDisabled={true} />
            <TextField name="sexo" label="Sexo" isDisabled={true} />
          </HStack>
          <HStack>
            <TextField name="nascimento" label="Nascimento" isDisabled={true} />
            <TextField name="fone" label="Telefone" isDisabled={true} />
          </HStack>
          <TextField name="email" label="E-mail" isDisabled={true} />
          <TextField name="endereco" label="Endereço" isDisabled={true} />
          <HStack>
            <Checkbox
              name="termos"
              onChange={(e) => {
                setTermos(e.target.checked);
              }}
            ></Checkbox>

            <chakra.a pl="10px" colorScheme="teal" onClick={termosGeraisApp.onOpen}>
              Li e aceito os <u>termos de uso</u>
            </chakra.a>
          </HStack>
          <HStack>
            <Checkbox
              name="termosGerais"
              onChange={(e) => {
                setTermosGerais(e.target.checked);
              }}
            ></Checkbox>

            <chakra.a pl="10px" colorScheme="teal" onClick={disclousureTermosGerais.onOpen}>
              Li e aceito os <u>termos de adesão do aplicativo</u>.
            </chakra.a>
          </HStack>
          <Button colorScheme="teal" w="100%" type="submit" isDisabled={!termos || !termosGerais}>
            Cadastrar
          </Button>
        </>
      );
    }
  }
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
  const userLogin = useCallback(async () => {
    const res = await api(`${ENDPOINT}/auth/login`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: onlyNumbers(state.cpf),
        password: state.senha,
      }),
    });

    if (!res || !res.ok || res.status >= 400) {
      throw new Error('Status login inválido');
    }

    return res.json();
  }, [state.cpf, state.senha]);

  console.log(state.assinatura);

  return (
    <>
      <Drawer isCentered isFullHeight size="md" isOpen={termosGeraisApp.isOpen} onClose={termosGeraisApp.onClose} placement="bottom">
        <DrawerContent isCentered nbgColor="rgba(90, 178, 173, 0.7)" pt="10%">
          <Pdf file={TermosGerais} />
          <DrawerCloseButton color="red" borderColor="red" pt="15%" />
        </DrawerContent>
      </Drawer>
      <Drawer isCentered isFullHeight size="md" isOpen={disclousureTermosGerais.isOpen} onClose={disclousureTermosGerais.onClose} placement="bottom">
        <DrawerContent isCentered nbgColor="rgba(90, 178, 173, 0.7)" pt="10%">
          <Pdf file={Contrato} />
          <DrawerCloseButton color="red" borderColor="red" pt="15%" />
        </DrawerContent>
      </Drawer>
      <NoUserHeader />
      <Formik
        initialValues={{
          cpf: state.cpf,
          nome: state.nome,
          email: state.email,
          fone: state.fone,
          nascimento: state.nascimento,
          sexo: sexo_nome(),
          endereco: `${state.endereco}, ${state.numero}, ${state.complemento}, ${state.bairro} - ${state.cidade}, ${state.estado} - CEP: ${state.cep}`,
        }}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={async (values, actions) => {
          let split_nascimento = state.nascimento.split('/');
          let clientData = [
            {
              nome: state.nome,
              cod_ibge: state.code_ibge,
              cep: state.cep,
              logradouro: state.endereco,
              numero: state.numero,
              complemento: state.complemento,
              bairro: state.bairro,
              sexo: state.sexo,
              nascimento: new Date(split_nascimento[2], split_nascimento[1] - 1, split_nascimento[0]),
              cpf: state.cpf,
              celular: state.fone,
              email: state.email,
              senha: state.senha,
              hash: hash,
            },
          ];

          api(`${ENDPOINT}/clients`, {
            signal: requestTimeout(timeOutInSeconds).signal,
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(clientData),
          })
            .catch((err) => {
              return;
            })
            .then((res) => {
              if (!res || !res.ok || res.status >= 400) {
                setError('Não foi possível concluir seu cadastro no momento');
                return;
              }
              return res.json();
            })
            .then(async (resposta) => {
              if (!resposta) return;
              let returnRequest = resposta?.clients[0];
              let returnRequestToken = resposta?.token;
              if (returnRequest.success) {
                if (returnRequest) {
                  localStorage.setItem('token', returnRequestToken);
                }
                let client = returnRequest.data;
                console.log('client cadastro', client);
                if (termosGerais && state.cpf) {
                  try {
                    await api(`${ENDPOINT}/pacientes/postAceiteTermoAdesao`, {
                      method: 'POST',
                      credentials: 'include',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        user: client.username,
                        lat: user.lat,
                        lng: user.lng,
                        versao: '2026.04',
                      }),
                    })
                      .then(async (res) => {
                        if (!res || !res.ok || res.status >= 400) {
                          console.log('Erro na resposta da API:', res);
                          throw new Error('Erro na resposta da API');
                        }
                        return await res.json();
                      })
                      .then(async (resposta) => {
                        if (resposta || resposta.success === true || resposta.success === 'true') {
                          setUser((prevState) => ({ ...prevState, termo: true }));
                        }
                      });
                  } catch (err) {}
                }

                if (state.assinatura !== null && state.assinatura !== undefined) {
                  const data = await userLogin();
                  if (data && data.loggedIn) {
                    setUser((prevState) => ({ ...prevState, ...data, build: prevState.build ? prevState.build : null, username: state.cpf }));
                  }
                  navigate('/pagamentos', { state: { ...state.assinatura.dados, carrinho: state.assinatura.carrinho } });
                  return;
                }

                if (state?.telemedicina !== null && state.telemedicina !== undefined) {
                  if (state?.telemedicina?.voucher !== null) {
                    await fetchVincularVoucher(
                      state?.telemedicina?.voucher?.voucher?.voucher,
                      state?.telemedicina?.valor_com_desconto,
                      state?.telemedicina?.valor,
                      state.cpf,
                    );
                  }
                  const data = await userLogin();

                  if (data && data.loggedIn) {
                    setUser((prevState) => ({ ...prevState, ...data, build: prevState.build ? prevState.build : null, username: state.cpf }));
                  }
                  navigate('/pagamentos', {
                    state: {
                      value: state.cpf,
                      name: state.nome,
                      telemedPaga: true,
                      parcelsActive: true,
                      valor: state?.telemedicina?.valor,
                      expiration_pix_in_min: 5,
                      service: 'credit',
                      navig_to: '/alerts/sucesso/telemedicina2/',
                      solicitacao: false,
                      valor_assinante: state?.telemedicina?.valor_assinante,
                      frequenciaText: state?.telemedicina?.frequenciaText,
                      item: [
                        {
                          nome: state.nome,
                          tipo: state.telemedicina.tipoAtendimento,
                          username: state.username,
                        },
                      ],
                      voucher: { tipo: 'Telemedicina', voucher: state.telemedicina.voucher.voucher },
                      valorEconomizado: state?.telemedicina?.valorEconomizado,
                      valor_com_desconto: state?.telemedicina?.valor_com_desconto,
                      fromCadastro: true,
                    },
                  });
                  return;
                }

                navigate('/cadastro/fim-cadastro-cliente', {
                  state: {
                    valor: state.valor,
                    service: state.service,
                    client_id: client.paciente_id,
                    name: state.nome,
                    cpf: state.cpf,
                    senha: state.senha,
                    phone: state.fone,
                  },
                });
              } else {
                if (returnRequest.data.error.substring(0, 3) === 'cpf') {
                  setError('Seu cadastro já foi finalizado, faça login para continuar');
                } else {
                  setError('Não foi possível concluir seu cadastro no momento');
                }
              }
            });
        }}
      >
        <VStack as={Form} w={{ base: '90%', md: '500px' }} m="auto" paddingBottom="5%" justify="top" marginTop="5%" spacing="1rem" align="start">
          <Heading fontSize="1em">Vamos conferir se os dados foram preenchidos corretamente.</Heading>
          <Text as="p" color="red.500">
            {error}
          </Text>
          {renderPage()}
        </VStack>
      </Formik>
    </>
  );
};

export default Conferencia;
